import React from 'react'
import LotteryResultSectionHeader from '../LotteryResultSectionHeader'

/** Static mock section: หวยออมสิน */
const LotteryResultStaticGsb: React.FC = () => (
  <div className="col-12 col-lg-6 px-1 mb-4">
    <LotteryResultSectionHeader
      title="หวยออมสิน"
      iconUrl="flag/gsb.png"
      drawLabel="งวด: 16-Aug-2024"
    />
    <div className="wrap-box p-2 pt-0 bgg-6 bdr-5">
      <div className="row mx--1">
        <div className="col-12 col-lg-6 px--1 mt-2 animateMe" data-animation="fadeInUp">
          <div className="t-medium c-white text-center">
            <small>3ตัวบน</small>
          </div>
          <div className="bg-white bdr-5 bx-sd p-1 text-center">
            <div className="px-1">
              <h5>รอผล</h5>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 px--1 mt-2 animateMe" data-animation="fadeInUp">
          <div className="t-medium c-white text-center">
            <small>2ตัวล่าง</small>
          </div>
          <div className="bg-white bdr-5 bx-sd p-1 text-center">
            <div className="px-1">
              <h5>รอผล</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default LotteryResultStaticGsb
